import {createSelector} from 'reselect';
import {getSelectedStarterpack} from '../../App/selectors';

export const selectSelectedStarterpackId = createSelector([getSelectedStarterpack], starterpack => starterpack);
